import {
  Inject,
  Injectable,
  InjectionToken,
  Injector,
  NgZone
} from '@angular/core';
import * as Sentry from '@sentry/angular';
import Rollbar from 'rollbar';
import { environment } from '../environments/environment';
import { VERSION } from '../environments/version';
import { ToastrService } from 'ngx-toastr';

export const SentryService = new InjectionToken<Rollbar>('sentry');

@Injectable()
export class SentryErrorHandler extends Sentry.SentryErrorHandler {
  constructor(@Inject(Injector) private injector: Injector) {
    super();
  }

  get toastr(): ToastrService {
    return this.injector.get(ToastrService);
  }

  handleError(err: any): void {
    if (environment.production) {
      super.handleError(err.originalError || err);
    }

    try {
      if (err.statusText && err.url) {
        this.toastr.error(this.getHttpError(err), 'A server error occurred');
        return;
      } else {
        this.toastr.error('An application error occurred');
      }
    } catch (e) {
      super.handleError(
        new Error('No Toaster Container, app may be prevented from loading')
      );
    }
    console.error(err);
  }

  getHttpError(response: Response) {
    return response.statusText + ' response from ' + response.url;
  }

  setUserDetails(user: {
    id: number;
    name: string;
    email: string;
    tenant: string;
  }) {
    Sentry.setUser({
      id: user.id,
      email: user.email,
      username: user.name
    });
    Sentry.setExtra('tenant', user.tenant);
    Sentry.setExtra('hash', VERSION.raw);
  }
}
